<template>
    <div v-if="ready">
        <MenuOctolo>
            <menu-home />
        </MenuOctolo>
        <Slide1 />
        <Slide2 />
        <Slide3 />
        <Slide4 />
        <Slide5 />
        <Slide6 />
        <Slide7 />
        <Slide8 />
        <FooterComponent />
    </div>
</template>

<script>
import MenuOctolo from '@/toremove/components/menu/Menu.vue';
import MenuHome   from '@/pages/homepage/Menu.vue';
import Slide1     from '@/pages/homepage/slide/Slide1.vue';
import Slide2     from '@/pages/homepage/slide/Slide2.vue';
import Slide3     from '@/pages/homepage/slide/Slide3.vue';
import Slide4     from '@/pages/homepage/slide/Slide4.vue';
import Slide5     from '@/pages/homepage/slide/Slide5.vue';
import Slide6     from '@/pages/homepage/slide/Slide6.vue';
import Slide7     from '@/pages/homepage/slide/Slide7.vue';
import Slide8     from '@/pages/homepage/slide/Slide8.vue';
import FooterComponent     from '@/toremove/components/octolo/utils/Footer.vue';

export default {
    name: 'HomePage',
    components: {
        MenuOctolo,
        MenuHome,
        Slide1,
        Slide2,
        Slide3,
        Slide4,
        Slide5,
        Slide6,
        Slide7,
        Slide8,
        FooterComponent,
    },
    async mounted(){
        await this.loadTranslate();
        await this.loadConfig();
        if ((import.meta.env.PROD) || (process.env.ENABLE_SENTRY)) {
            this.$sentry.getCurrentScope().addEventProcessor(event => {
                event.release = this.$store.getters['User/getRelease'];
                return event;
            });
        }
        this.ready = true;
    },
}
</script>

<style lang="scss">
@import "@/assets/octolo.scss";
</style>
